import axiosInstance from "./axios.service"

export interface ItemRanking {
  _id?: string
  item: string
  rankings: string[]
}

export default { query, queryNoPaginate, save, remove }

async function query(filter: any): Promise<ItemRanking[]> {
  const params = { _select: '*', ...filter }
  const result = await axiosInstance.get('/api/itemRanking', { params })
  return result.data
}

async function queryNoPaginate(filter: any): Promise<ItemRanking[]> {
  const params = { _select: '*', ...filter, _paginate: false }
  const result = await axiosInstance.get('/api/itemRanking', { params })
  return result.data
}

async function save(data: ItemRanking): Promise<ItemRanking> {
  const result = await axiosInstance.post('/api/itemRanking', data)
  return result.data
}

async function remove(_id: string): Promise<ItemRanking> {
  if (!_id || _id.trim() === '') throw new Error('No se puede borrar sin id')
  const result = await axiosInstance.put('/api/itemRanking', { _id })
  return result.data
}
